import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import {
	BillingCycleChangeRequest,
	BillingCycleChangeResult,
} from '../../../admin/components/tools/UpgradeWizard/types';
import { invalidateSubscriptionState } from './useSubscriptionStateQuery';

export function useExecuteBillingCycleChangeMutation() {
	const userSession = useAdminUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (request: BillingCycleChangeRequest) => {
			return userSession.webServiceHelper.callAsync<BillingCycleChangeResult>(
				'admin/BillingUtilities/ExecuteBillingCycleChange',
				'POST',
				request
			);
		},
		onSuccess: (_data, variables) => {
			invalidateSubscriptionState(queryClient, variables.accountId);
		},
	});
}
